"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Loadable = /** @class */ (function (_super) {
    tslib_1.__extends(Loadable, _super);
    function Loadable(props) {
        var _this = _super.call(this, props) || this;
        _this.resolveModule = function (moduleItem, key) {
            if (key === void 0) { key = 'default'; }
            if (typeof moduleItem === 'function') {
                return moduleItem;
            }
            if (!moduleItem[key]) {
                console.warn("You have used <Loadable />, but module you are accessing via 'loader' prop has different exports. Use componentKey=\"" + Object.keys(moduleItem).slice(0) + "\" to access exported component property. ");
            }
            return moduleItem[key];
        };
        /* For node.js environment (unit tests) it will be transpiled into sync `require`.
         We don't want to break them and allowing to have both sync and async flow according to environment.
         With webpack build (development, e2e) we'll have `import` not transpiled to `require`, which will create
         async flow. We should determine type of flow and according to it sync or async set the state.
        */
        _this.loadSyncOrAsync = function () {
            var _a = _this.props, loader = _a.loader, _b = _a.namedExports, namedExports = _b === void 0 ? {} : _b;
            var resolvedModules = {};
            var resolvedAsyncModules = {};
            var _loop_1 = function (loadableItemKey) {
                var loadableItem = loader[loadableItemKey]();
                if (loadableItem instanceof Promise) {
                    // Handling `import('Tooltop') -> Promise<module>`
                    resolvedAsyncModules[loadableItemKey] = loadableItem
                        .then(function (loaded) {
                        return _this.resolveModule(loaded, namedExports[loadableItemKey]);
                    })
                        .catch(function () {
                        console.error("Asset wasn't loaded: " + loadableItem);
                    });
                }
                else {
                    // Handling `require('Tooltop') -> module`
                    resolvedModules[loadableItemKey] = _this.resolveModule(loadableItem, namedExports[loadableItemKey]);
                }
            };
            for (var loadableItemKey in loader) {
                _loop_1(loadableItemKey);
            }
            var isAsyncMode = Object.keys(resolvedAsyncModules).length > 0;
            if (!isAsyncMode) {
                return resolvedModules;
            }
            var resolvedKeys = Object.keys(resolvedAsyncModules);
            Promise.all(resolvedKeys.map(function (key) { return resolvedAsyncModules[key]; })).then(function (modules) {
                modules.forEach(function (resolvedModule, index) {
                    var moduleName = resolvedKeys[index];
                    resolvedModules[moduleName] = resolvedModule;
                });
                _this.setState({ loaded: resolvedModules, isLoading: false });
            });
            return null;
        };
        var loaded = null;
        if (props.shouldLoadComponent) {
            loaded = _this.loadSyncOrAsync();
        }
        var isLoading = props.shouldLoadComponent && !loaded;
        _this.state = {
            loaded: loaded,
            isLoading: isLoading,
        };
        return _this;
    }
    Loadable.prototype.componentDidUpdate = function (prevProps) {
        // Here we want to start loading the component only when `shouldLoadComponent` was changed
        // and we are not already loading the component.
        if (!this.state.loaded &&
            !prevProps.shouldLoadComponent &&
            this.props.shouldLoadComponent &&
            !this.state.isLoading) {
            var loaded = null;
            loaded = this.loadSyncOrAsync();
            this.setState({ loaded: loaded, isLoading: !loaded });
        }
    };
    Loadable.prototype.render = function () {
        var _a = this.state, loaded = _a.loaded, isLoading = _a.isLoading;
        var _b = this.props, shouldLoadComponent = _b.shouldLoadComponent, defaultComponent = _b.defaultComponent, loadingComponent = _b.loadingComponent, children = _b.children;
        // Handling loader. Using defaultComponent if no loader was specified.
        if (isLoading) {
            return loadingComponent || defaultComponent;
            // Handling error or component when loading wasn't started
        }
        if (!shouldLoadComponent || !loaded) {
            return defaultComponent;
        }
        // Rendering original loaded component.
        return children(loaded);
    };
    return Loadable;
}(React.Component));
exports.Loadable = Loadable;
//# sourceMappingURL=Loadable.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/loadable/Loadable.js
// module id = 1247
// module chunks = 0